(() => {
  'use strict';

  const finder = document.querySelector('.db-routine-finder');
  const form = finder?.querySelector('[data-db-routine-form]');
  const result = finder?.querySelector('[data-db-routine-result]');
  if (!finder || !form || !result) return;

  let stock = {};
  try {
    stock = JSON.parse(finder.querySelector('[data-db-finder-routines]')?.textContent || '{}') || {};
  } catch (error) {
    stock = {};
  }

  const sizes = [
    'the 3 essentials: cleanse, treat, moisturize',
    'the 3 essentials plus a toner and a daily sunscreen',
    'everything in the 5-Step plus a booster step and an eye treatment'
  ];
  const info = {
    'healthy-cleanse-refresh-routine': { built: 'a deep-cleansing heartleaf foam, a hyaluronic acid serum and a black rice hyaluronic cream for clean, comfortable, healthy-looking skin', sizes, spf: 1, ret: 2 },
    'healthy-hydrate-plump-routine': { built: 'a gentle zero-foam cleanser, a collagen jelly cream and a low-molecular hyaluronic acid serum for juicy, plump-looking hydration', sizes, spf: 1 },
    'healthy-calm-barrier-routine': { built: 'a mugwort calming cleanser, a PDRN hyaluronic cream and a cica serum to calm the look of redness and keep the skin barrier comfy', sizes, spf: 1, ret: 2 },
    'healthy-brighten-glow-routine': { built: 'a pore-deep heartleaf cleansing foam, a propolis and niacinamide glow serum and a hyaluronic moisture cream for a brighter, more even-looking glow', sizes, spf: 1, vitc: 1, ret: 2 },
    'healthy-clear-pores-routine': { built: 'a salicylic acid cleansing foam, a BHA blackhead liquid and a black rice hyaluronic cream for clearer-looking skin and smoother-looking pores', sizes, spf: 1, bha: true, ret: 2 },
    'healthy-repair-protect-routine': { built: 'a low-pH gel cleanser, a snail mucin essence and a snail all-in-one cream to help skin look and feel repaired and protected', sizes, spf: 1 },
    'healthy-firm-renew-routine': { built: 'a mugwort calming cleanser, a vitamin concentrated serum and a black rice hyaluronic cream for firmer, bouncier-looking skin', sizes, spf: 1, ret: 2 }
  };

  const skinWords = { dry: 'dry', oily: 'oily', combination: 'combination', normal: 'normal' };
  const sensWords = { yes: ' that reacts easily', sometimes: ' that can be a little sensitive', rarely: '' };
  const wishWords = {
    healthy: 'healthier-looking skin',
    hydrate: 'juicy, hydrated skin',
    glow: 'a glass-skin glow',
    bright: 'a brighter, more even tone',
    clear: 'clearer-looking skin',
    texture: 'smoother-looking pores and texture',
    firm: 'firmer, bouncier-looking skin',
    calm: 'calmer, happier skin'
  };
  const skinTips = {
    dry: 'Dry skin tip: pat each step onto slightly damp skin and never skip the cream.',
    oily: 'Oily skin tip: a thin layer of each step is plenty. Hydration actually helps balance shine.',
    combination: 'Combination skin tip: go lighter on your T-zone and a little richer on drier cheeks.',
    normal: 'Normal skin tip: follow every step as written and enjoy the glow.'
  };

  const R = {
    clean: 'healthy-cleanse-refresh-routine',
    hydrate: 'healthy-hydrate-plump-routine',
    calm: 'healthy-calm-barrier-routine',
    bright: 'healthy-brighten-glow-routine',
    clear: 'healthy-clear-pores-routine',
    repair: 'healthy-repair-protect-routine',
    firm: 'healthy-firm-renew-routine'
  };

  function preferences(a) {
    const reactive = a.sens === 'yes';
    switch (a.goal) {
      case 'healthy':
        return reactive ? [R.calm, R.hydrate, R.clean, R.repair] : [R.clean, R.bright, R.hydrate, R.repair];
      case 'calm':
        return [R.calm, R.repair, R.hydrate];
      case 'hydrate':
        return reactive ? [R.calm, R.hydrate, R.repair] : [R.hydrate, R.repair, R.calm];
      case 'glow':
        if (reactive) return [R.calm, R.bright, R.hydrate];
        return a.skin === 'dry' ? [R.bright, R.hydrate, R.clean] : [R.bright, R.clean, R.hydrate];
      case 'bright':
        return reactive ? [R.bright, R.calm, R.clean] : [R.bright, R.clean, R.hydrate];
      case 'clear':
        return reactive ? [R.calm, R.clear, R.repair] : [R.clear, R.clean, R.calm];
      case 'texture':
        return reactive ? [R.calm, R.clear] : [R.clear, R.bright, R.clean];
      case 'firm':
        return [R.firm, R.repair, R.hydrate];
      default:
        return [R.calm, R.clean];
    }
  }

  function choose(a) {
    const list = preferences(a);
    const ideal = list.find((h) => stock[h]) || null;
    const pick = list.find((h) => stock[h] && stock[h].available) || null;
    return { ideal, pick };
  }

  const steps = Array.from(form.querySelectorAll('[data-db-quiz-step]'));
  const progress = form.querySelector('[data-db-quiz-progress]');
  const count = form.querySelector('[data-db-quiz-count]');
  const bar = form.querySelector('[data-db-quiz-bar]');
  const back = form.querySelector('[data-db-quiz-back]');
  const next = form.querySelector('[data-db-quiz-next]');
  const submit = form.querySelector('[data-db-quiz-submit]');
  let current = 0;
  let pointerPick = false;

  const answered = (step) => step.hasAttribute('data-db-quiz-optional') || !!step.querySelector('input:checked');
  const questionTotal = steps.filter((s) => !s.hasAttribute('data-db-quiz-optional')).length;

  function show(index, focus) {
    current = Math.max(0, Math.min(index, steps.length - 1));
    steps.forEach((step, i) => { step.hidden = i !== current; });
    const last = current === steps.length - 1;
    if (progress) progress.hidden = false;
    if (count) count.textContent = steps[current].hasAttribute('data-db-quiz-optional') ? 'Last step · optional' : 'Question ' + (current + 1) + ' of ' + questionTotal;
    if (bar) bar.style.width = ((current + 1) / steps.length) * 100 + '%';
    if (back) back.hidden = current === 0;
    if (next) { next.hidden = last; next.disabled = !answered(steps[current]); }
    if (submit) { submit.hidden = !last; submit.disabled = !answered(steps[current]); }
    if (focus) {
      const target = steps[current].querySelector('input:checked') || steps[current].querySelector('input');
      target?.focus({ preventScroll: true });
    }
    if (form.getBoundingClientRect().top < 0) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  if (steps.length) {
    finder.classList.add('is-stepped');
    show(0, false);
    form.addEventListener('pointerdown', () => { pointerPick = true; });
    form.addEventListener('keydown', () => { pointerPick = false; });
    form.addEventListener('change', (event) => {
      if (event.target?.type !== 'radio') return;
      const last = current === steps.length - 1;
      if (next) next.disabled = false;
      if (submit && last) submit.disabled = false;
      if (!pointerPick) return;
      window.setTimeout(() => {
        if (last) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(); else submit?.click();
        } else {
          show(current + 1, false);
        }
      }, 280);
    });
    next?.addEventListener('click', () => { if (answered(steps[current])) show(current + 1, true); });
    back?.addEventListener('click', () => show(current - 1, true));
  }

  const emailBox = finder.querySelector('[data-db-quiz-email]');
  const showEmail = () => { if (emailBox) emailBox.hidden = false; };
  if (emailBox && (/customer_posted=true/.test(window.location.search) || emailBox.querySelector('.form-message--error'))) {
    showEmail();
    emailBox.scrollIntoView({ block: 'center' });
  }

  const toCents = (t) => {
    const m = String(t || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return m ? Math.round(parseFloat(m[0]) * 100) : 0;
  };
  const salePct = () => {
    const s = window.DanellaSale;
    return s && s.routine > 0 ? s.routine : 0;
  };
  const salePrice = (t) => {
    const pct = salePct();
    const c = toCents(t);
    if (!pct || !c) return t;
    return '$' + ((c - Math.round((c * pct) / 100)) / 100).toFixed(2);
  };

  /* Single-size routines ("Default Title") show no size name. */
  const sizeLabel = (v) => (v.title && v.title !== 'Default Title' ? v.title + ' · ' : '');

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const missing = steps.findIndex((step) => !answered(step));
    if (missing !== -1) { show(missing, true); form.reportValidity(); return; }

    const a = Object.fromEntries(new FormData(form).entries());
    const { ideal, pick } = choose(a);
    const titleEl = result.querySelector('[data-db-result-title]');
    const sizeEl = result.querySelector('[data-db-result-size]');
    const reasonEl = result.querySelector('[data-db-result-reason]');
    const tipsEl = result.querySelector('[data-db-result-tips]');
    const noteEl = result.querySelector('[data-db-result-note]');
    const img = result.querySelector('[data-db-result-img]');
    const link = result.querySelector('[data-db-result-link]');
    const addForm = result.querySelector('[data-db-result-add]');
    const addId = result.querySelector('[data-db-result-variant]');
    const addBtn = result.querySelector('[data-db-result-add-btn]');

    const tags = ['newsletter', 'skin-quiz', 'quiz-' + a.goal, 'quiz-skin-' + a.skin, 'quiz-sens-' + a.sens];

    const shown = pick || ideal;
    if (!shown) {
      titleEl.textContent = 'Our routines are restocking';
      sizeEl.textContent = '';
      reasonEl.textContent = 'Every routine that fits your answers is restocking right now. Browse what\'s in stock, or leave your email below and we\'ll let you know.';
      tipsEl.innerHTML = '';
      noteEl.hidden = true;
      if (img) img.hidden = true;
      if (addForm) addForm.hidden = true;
      link.href = finder.dataset.urlDirectory || '/collections/all';
      link.textContent = 'Browse all routines ↗';
    } else {
      const r = stock[shown];
      const meta = info[shown] || { built: '', sizes: [], spf: -1 };
      let size = parseInt(a.size, 10) || 0;
      if (!r.variants[size]) size = 0;
      if (pick && !r.variants[size].available) {
        const fallback = r.variants.findIndex((v) => v.available);
        size = fallback === -1 ? 0 : fallback;
      }
      const variant = r.variants[size];
      const pct = salePct();
      const nowPrice = pct ? salePrice(variant.price) : variant.price;
      const onSale = !!pct && nowPrice !== variant.price;

      titleEl.textContent = r.title;
      sizeEl.innerHTML = '';
      const sizeName = document.createElement('strong');
      sizeName.textContent = sizeLabel(variant) + nowPrice;
      if (onSale) {
        const was = document.createElement('s');
        was.textContent = variant.price;
        was.style.cssText = 'margin-left:8px;font-weight:400;opacity:.6';
        sizeName.append(was);
      }
      if (!pick) sizeName.append(' · coming soon');
      sizeEl.appendChild(sizeName);
      if (meta.sizes[size]) {
        const sizeInfo = document.createElement('small');
        sizeInfo.textContent = 'Includes ' + meta.sizes[size];
        sizeEl.appendChild(sizeInfo);
      }
      const priceNote = document.createElement('small');
      priceNote.textContent = onSale
        ? 'Sale price: ' + pct + '% off, applied automatically in your bag. There is no code to enter.'
        : 'That is the price you pay. Our savings are already built in, so there is no code to enter.';
      sizeEl.appendChild(priceNote);

      reasonEl.textContent = 'Because you have ' + skinWords[a.skin] + ' skin' + sensWords[a.sens] +
        ' and want ' + wishWords[a.goal] + ', we matched you with the ' + r.title + '. It\'s built around ' + meta.built + '.';

      const tips = [skinTips[a.skin]];
      if (a.sens !== 'rarely') {
        const before = tips.length;
        if (meta.vitc !== undefined && size >= meta.vitc) tips.push('Sensitive skin tip: use the vitamin C step every other day for the first week, then build up.');
        if (meta.ret !== undefined && size >= meta.ret) tips.push('Sensitive skin tip: the eye treatment in this size has a retinol-type ingredient, so start with two nights a week and build up slowly.');
        if (meta.bha) tips.push('Sensitive skin tip: start the BHA step once or twice a week and build up slowly.');
        if (tips.length === before) tips.push(a.sens === 'yes'
          ? 'Sensitive skin tip: patch test first and add one new product every few days.'
          : 'Add new products one at a time so you can see how your skin likes them.');
      }
      if (meta.spf === -1 || size < meta.spf) tips.push('Finish every morning with a sunscreen. This size does not include one, so add the sunscreen on the routine page or use your own.');
      tipsEl.innerHTML = '';
      tips.forEach((t) => { const li = document.createElement('li'); li.textContent = t; tipsEl.appendChild(li); });

      if (pick && ideal && ideal !== pick && stock[ideal]) {
        noteEl.innerHTML = '';
        noteEl.append('Your closest match for ' + wishWords[a.goal] + ' is our ');
        const a2 = document.createElement('a');
        a2.href = stock[ideal].url;
        a2.textContent = stock[ideal].title;
        noteEl.append(a2, ', which is restocking soon. Until then, this is the best in-stock routine for your skin.');
        noteEl.hidden = false;
      } else if (!pick) {
        noteEl.textContent = 'Good news: this routine is coming soon. Leave your email below and we will tell you the moment it is in stock.';
        noteEl.hidden = false;
      } else {
        noteEl.hidden = true;
      }

      if (img) {
        if (r.img) { img.src = r.img; img.alt = r.title; img.hidden = false; } else { img.hidden = true; }
        /* Show the picture for the size that was matched (3-, 5- or 7-Step), not always the 3-Step one. */
        const vid = variant.id;
        fetch(String(r.url).split('?')[0] + '.js').then((x) => x.json()).then((p) => {
          const v = (p.variants || []).find((q) => q.id === vid);
          const src = v && v.featured_image && v.featured_image.src;
          if (src && link.href.indexOf('variant=' + vid) > -1) {
            img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=640';
            img.hidden = false;
          }
        }).catch(() => {});
      }
      if (addForm && addId && addBtn) {
        addId.value = variant.id;
        addBtn.textContent = 'Add ' + (variant.title !== 'Default Title' ? variant.title + ' ' : '') + 'to bag · ' + nowPrice;
        addForm.hidden = !variant.available;
      }
      link.href = r.url + '?variant=' + variant.id;
      link.textContent = 'See the routine & how to use it ↗';
      tags.push('quiz-' + shown.replace(/-routine$/, ''));
    }

    const tagsInput = emailBox?.querySelector('[data-db-quiz-tags]');
    if (tagsInput) tagsInput.value = tags.join(',');
    form.hidden = true;
    result.hidden = false;

    const sentEl = result.querySelector('[data-db-quiz-sent]');
    const emailVal = (form.querySelector('[data-db-quiz-email-input]')?.value || '').trim();
    if (emailVal && /^\S+@\S+\.\S+$/.test(emailVal)) {
      if (sentEl) sentEl.hidden = false;
      const fail = () => { if (sentEl) sentEl.hidden = true; showEmail(); };
      try {
        const body = new URLSearchParams({ form_type: 'customer', utf8: '✓', 'contact[email]': emailVal, 'contact[tags]': tags.join(',') });
        fetch('/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString(), credentials: 'same-origin' })
          .then((res) => { if (!res || !res.ok || /\/challenge/.test(res.url || '')) fail(); })
          .catch(fail);
      } catch (error) {
        fail();
      }
    } else {
      showEmail();
    }
    result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    titleEl.setAttribute('tabindex', '-1');
    titleEl.focus({ preventScroll: true });
  });

  result.querySelector('[data-db-result-reset]')?.addEventListener('click', () => {
    result.hidden = true;
    form.hidden = false;
    if (steps.length) show(0, true);
  });
})();